// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1gAbS","title":"AfterBackImages_title__29wrR","images":"AfterBackImages_images__2rZd3"};